import RegisterMap from './RegisterMap'
export default RegisterMap
